import { type ReactNode, useEffect } from 'react';
import { useScrollLock } from '@shared/hook';
import { cn } from '@shared/utils';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  titleClassName?: string;
  width?: string | number;
  setAutoCloseSeconds?: number;
  title?: string;
  children: ReactNode;
}

export const Modal = (props: ModalProps) => {
  const { lock, unlock } = useScrollLock({ autoLock: false });

  useEffect(() => {
    props.isOpen ? lock() : unlock();
  }, [props.isOpen]);

  useEffect(() => {
    if (!props.isOpen || !props.setAutoCloseSeconds) return;
    const timerId = setTimeout(() => props.onClose?.(), props.setAutoCloseSeconds * 1000);
    return () => clearTimeout(timerId);
  }, [props.isOpen, props.setAutoCloseSeconds]);

  if (!props.isOpen) return;
  return (
    <div
      className={cn(
        'fixed top-0 right-0 bottom-0 left-0 z-[1500] flex h-full items-center justify-center overflow-y-auto bg-[#191919cc] transition-colors duration-300',
        'max-md:items-start max-md:justify-start',
        // props.isOpen ? 'animation-in' : 'animation-out',
        // screen.width < 760 && 'mobile',
      )}
    >
      <div
        className={cn(
          'relative min-h-[467px] w-[470px] overflow-y-auto rounded-sm bg-[#2f3030] px-17.5 shadow-[12px_12px_24px_0_#0000003b] transition-all duration-300',
          'max-md:m-auto max-md:min-h-full max-md:w-full max-md:p-0 max-md:px-10.5',
          // screen.width < 760 && 'modal-mobile',
          props.className,
        )}
      >
        <div className='flex h-full flex-col items-start justify-between pt-9 pb-11 max-md:min-h-full max-md:p-0 max-md:py-6.5'>
          {props.title && (
            <h2
              className='mx-auto mr-[-30px] mb-4 ml-[-30px] overflow-hidden border-b border-b-[#9191911a] pb-4 text-center text-[17px] font-bold text-ellipsis whitespace-nowrap text-[#fff] uppercase max-[414px]:whitespace-normal'
              style={{ width: 'calc(100% + 60px)' }}
            >
              {props.title}
            </h2>
          )}
          {props.children}
        </div>
      </div>
    </div>
  );
};
